/**
 * Filled by data from API call
 * /umbraco/delivery/api/v2/content?filter=contentType:titleTextItem
 */
export default class TextTitleItem {
    fetchKey: string;
    title: string | null;
    paragraph: string | null;
    aside: string | null;
    
    constructor(fetchKey: string, title: string | null, paragraph: string | null, aside: string | null) {
        this.fetchKey = fetchKey;
        this.title = title;
        this.paragraph = paragraph;
        this.aside = aside;
    }
}

export interface TextTitleItemProperties {
    textTitle: TextTitleItem | undefined;
}